module.exports = __webpack_public_path__ + "img/69824569f927b7636b1643ee3eccc391.png";